import { SecondFromMidnight, TimeSlot } from "@cervval.js/calendars/src/calendars.definition";
import { FieldMarshaller } from "@cervval.js/common-sql-core";
import { DAYS } from "@cervval.js/common/src/tools/timestamps.tools.definitions";
import { anyReallyAny } from "@cervval.js/common/tools";
import { SIRETFieldTypes, getMarshallerRecordForSIRETFieldTypes } from "@ehealth_tools/common-siret/src/types/siret.types";
import { BooleanFieldMarshaller, jsonDataFieldMarshaller } from "@ehealth_tools/common/src/data/propertyTypes/property.marshallers";
import { FieldTypes } from "@ehealth_tools/common/src/data/propertyTypes/property.types";

export const _SAFE_SHARING = {
    NONE: "none",
    TIMESLOT_ONLY: "timeslot_only"
} as const;

export const _UNSAFE_SHARING = {
    ..._SAFE_SHARING,
    FULL: "full"
} as const;

export type SAFE_SHARING = typeof _SAFE_SHARING[keyof typeof _SAFE_SHARING];
export type UNSAFE_SHARING = typeof _UNSAFE_SHARING[keyof typeof _UNSAFE_SHARING];

export enum GENDER {
    FEMALE = 1,
    MALE = 2
}

export enum BOOKING_USER_TYPE {
    CLIENT = 1,
    PROFESSIONAL = 2
}

export interface CalendarDay {
    timeslots: TimeSlot[];
}

export type WEEK_DATA = {
    [DAYS.MONDAY]?: CalendarDay,
    [DAYS.TUESDAY]?: CalendarDay,
    [DAYS.WEDNESDAY]?: CalendarDay,
    [DAYS.THURSDAY]?: CalendarDay,
    [DAYS.FRIDAY]?: CalendarDay,
    [DAYS.SATURDAY]?: CalendarDay,
    [DAYS.SUNDAY]?: CalendarDay
}

export type BookingFieldTypes = {
    "WEEK_DATA": WEEK_DATA,
    "SecondFromMidnight": SecondFromMidnight,
    "SAFE_SHARING": SAFE_SHARING,
    "UNSAFE_SHARING": UNSAFE_SHARING,
    "GENDER": GENDER,
    "BOOKING_USER_TYPE": BOOKING_USER_TYPE
} & FieldTypes & SIRETFieldTypes

// FieldTypeNames are used in SQL table definitions in order to define which marshallers should be used to marshal / unmarshal object from / to DB
export type BookingFieldTypeName = keyof BookingFieldTypes;

/** Register on the marshallers map (app) the module marshallers */
export function registerBookingMarshallers<AppFieldType extends BookingFieldTypes>(marshallers: Map<keyof AppFieldType, FieldMarshaller<AppFieldType[keyof AppFieldType]> | string>): void {
    marshallers.set("WEEK_DATA", jsonDataFieldMarshaller as anyReallyAny);
    marshallers.set("BOOLEAN", BooleanFieldMarshaller as anyReallyAny);

    const siretMarshallers = getMarshallerRecordForSIRETFieldTypes();
    if (siretMarshallers.SIRET != null) {
        marshallers.set("SIRET", siretMarshallers.SIRET as anyReallyAny);
    }
}